function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var validSubscriptionKeys = ['address', 'network', 'balance', 'wallet'];

function validateType(options) {
  var name = options.name,
      value = options.value,
      type = options.type,
      optional = options.optional;

  if (!optional && typeof value === 'undefined') {
    throw new Error("\"".concat(name, "\" is required"));
  }

  if (typeof value !== 'undefined' && (type === 'array' ? Array.isArray(type) : _typeof(value) !== type)) {
    throw new Error("\"".concat(name, "\" must be of type: ").concat(type, ", received type: ").concat(_typeof(value), " from value: ").concat(value));
  }
}

function invalidParams(params, validParams, functionName) {
  var invalid = Object.keys(params);

  if (invalid.length > 0) {
    throw new Error("".concat(invalid[0], " is not a valid parameter for ").concat(functionName, ", must be one of the following valid parameters: ").concat(validParams.join(', ')));
  }
}

function validateInit(init) {
  validateType({
    name: 'init',
    value: init,
    type: 'object'
  });

  var dappId = init.dappId,
      networkId = init.networkId,
      subscriptions = init.subscriptions,
      walletSelect = init.walletSelect,
      walletCheck = init.walletCheck,
      darkMode = init.darkMode,
      otherParams = _objectWithoutProperties(init, ["dappId", "networkId", "subscriptions", "walletSelect", "walletCheck", "darkMode"]);

  invalidParams(otherParams, ['dappId', 'networkId', 'subscriptions', 'walletSelect', 'walletCheck', 'darkMode'], 'init');
  validateType({
    name: 'dappId',
    value: dappId,
    type: 'string'
  });
  validateType({
    name: 'networkId',
    value: networkId,
    type: 'number'
  });
  validateType({
    name: 'darkMode',
    value: darkMode,
    type: 'boolean',
    optional: true
  });
  validateType({
    name: 'subscriptions',
    value: subscriptions,
    type: 'object',
    optional: true
  });

  if (subscriptions) {
    validateSubscriptions(subscriptions);
  }

  validateType({
    name: 'walletSelect',
    value: walletSelect,
    type: 'object',
    optional: true
  });

  if (walletSelect) {
    validateWalletSelect(walletSelect);
  }

  validateType({
    name: 'walletCheck',
    value: walletCheck,
    type: 'object',
    optional: true
  });

  if (walletCheck) {
    validateWalletCheck(walletCheck);
  }
}

function validateSubscriptions(subscriptions) {
  var address = subscriptions.address,
      network = subscriptions.network,
      balance = subscriptions.balance,
      wallet = subscriptions.wallet,
      otherParams = _objectWithoutProperties(subscriptions, ["address", "network", "balance", "wallet"]);

  invalidParams(otherParams, validSubscriptionKeys, 'subscriptions');
  validateType({
    name: 'subscriptions.address',
    value: address,
    type: 'function',
    optional: true
  });
  validateType({
    name: 'subscriptions.network',
    value: network,
    type: 'function',
    optional: true
  });
  validateType({
    name: 'subscriptions.balance',
    value: balance,
    type: 'function',
    optional: true
  });
  validateType({
    name: 'subscriptions.wallet',
    value: wallet,
    type: 'function',
    optional: true
  });
}

function validateWalletSelect(walletSelect) {
  validateType({
    name: 'walletSelect',
    value: walletSelect,
    type: 'object'
  });

  var heading = walletSelect.heading,
      description = walletSelect.description,
      wallets = walletSelect.wallets,
      otherParams = _objectWithoutProperties(walletSelect, ["heading", "description", "wallets"]);

  invalidParams(otherParams, ['heading', 'description', 'wallets'], 'walletSelect');
  validateType({
    name: 'heading',
    value: heading,
    type: 'string',
    optional: true
  });
  validateType({
    name: 'description',
    value: description,
    type: 'string',
    optional: true
  });

  if (Array.isArray(wallets)) {
    wallets.forEach(validateWallet);
  }
}

function isWalletModule(obj) {
  return obj.wallet !== undefined;
}

function isWalletInit(obj) {
  return obj.walletName !== undefined;
}

function validateWallet(obj) {
  validateType({
    name: 'selectWallet.wallets item',
    value: obj,
    type: 'object'
  });

  if (isWalletModule(obj)) {
    var name = obj.name,
        iconSrc = obj.iconSrc,
        iconSrcSet = obj.iconSrcSet,
        svg = obj.svg,
        wallet = obj.wallet,
        link = obj.link,
        installMessage = obj.installMessage,
        preferred = obj.preferred,
        desktop = obj.desktop,
        mobile = obj.mobile,
        otherParams = _objectWithoutProperties(obj, ["name", "iconSrc", "iconSrcSet", "svg", "wallet", "link", "installMessage", "preferred", "desktop", "mobile"]);

    invalidParams(otherParams, ['name', 'iconSrc', 'iconSrcSet', 'svg', 'wallet', 'link', 'installMessage', 'preferred', 'desktop', 'mobile'], 'selectWallets.wallets item');
    validateType({
      name: 'name',
      value: name,
      type: 'string'
    });
    validateType({
      name: 'wallet',
      value: wallet,
      type: 'function'
    });
    validateType({
      name: 'iconSrc',
      value: iconSrc,
      type: 'string',
      optional: true
    });
    validateType({
      name: 'iconSrcSet',
      value: iconSrcSet,
      type: 'string',
      optional: true
    });
    validateType({
      name: 'svg',
      value: svg,
      type: 'string',
      optional: true
    });
    validateType({
      name: 'link',
      value: link,
      type: 'string',
      optional: true
    });
    validateType({
      name: 'installMessage',
      value: installMessage,
      type: 'function',
      optional: true
    });
    validateType({
      name: 'preferred',
      value: preferred,
      type: 'boolean',
      optional: true
    });
    validateType({
      name: 'desktop',
      value: desktop,
      type: 'boolean',
      optional: true
    });
    validateType({
      name: 'mobile',
      value: mobile,
      type: 'boolean',
      optional: true
    });
    return;
  }

  validateWalletInit(obj);
}

function isWalletCheckModule(obj) {
  return typeof obj === 'function';
}

function validateWalletCheck(walletCheck) {
  validateType({
    name: 'walletCheck',
    value: walletCheck,
    type: 'array'
  });
  walletCheck.forEach(function (check) {
    if (isWalletCheckModule(check)) {
      validateWalletCheckModule(check);
    } else {
      validateType({
        name: 'walletCheck item',
        value: check,
        type: 'object'
      });

      var checkName = check.checkName,
          minimumBalance = check.minimumBalance,
          otherParams = _objectWithoutProperties(check, ["checkName", "minimumBalance"]);

      invalidParams(otherParams, ['checkName', 'minimumBalance'], 'walletCheck item');
      validateType({
        name: 'checkName',
        value: checkName,
        type: 'string'
      });
      validateType({
        name: 'minimumBalance',
        value: minimumBalance,
        type: 'string',
        optional: true
      });
    }
  });
}

function validateWalletCheckModule(module) {
  validateType({
    name: 'walletCheck module',
    value: module,
    type: 'function'
  });
}

function validateConfig(configuration) {
  validateType({
    name: 'configuration',
    value: configuration,
    type: 'object'
  });

  var darkMode = configuration.darkMode,
      networkId = configuration.networkId,
      otherParams = _objectWithoutProperties(configuration, ["darkMode", "networkId"]);

  invalidParams(otherParams, ['darkMode', 'networkId'], 'configuration');
  validateType({
    name: 'darkMode',
    value: darkMode,
    type: 'boolean',
    optional: true
  });
  validateType({
    name: 'networkId',
    value: networkId,
    type: 'number',
    optional: true
  });
}

function validateModal(modal) {
  validateType({
    name: 'modal',
    value: modal,
    type: 'object'
  });

  var heading = modal.heading,
      description = modal.description,
      button = modal.button,
      eventCode = modal.eventCode,
      action = modal.action,
      icon = modal.icon,
      loading = modal.loading,
      otherParams = _objectWithoutProperties(modal, ["heading", "description", "button", "eventCode", "action", "icon", "loading"]);

  invalidParams(otherParams, ['heading', 'description', 'button', 'eventCode', 'action', 'icon'], 'modal');
  validateType({
    name: 'heading',
    value: heading,
    type: 'string'
  });
  validateType({
    name: 'description',
    value: description,
    type: 'string'
  });
  validateType({
    name: 'eventCode',
    value: eventCode,
    type: 'string'
  });
  validateType({
    name: 'action',
    value: action,
    type: 'function',
    optional: true
  });
  validateType({
    name: 'loading',
    value: loading,
    type: 'object',
    optional: true
  });
  validateType({
    name: 'button',
    value: button,
    type: 'object',
    optional: true
  });

  if (button) {
    var onclick = button.onclick,
        text = button.text,
        restParams = _objectWithoutProperties(button, ["onclick", "text"]);

    invalidParams(restParams, ['onclick', 'text'], 'button');
    validateType({
      name: 'onclick',
      value: onclick,
      type: 'function'
    });
    validateType({
      name: 'text',
      value: text,
      type: 'string'
    });
  }

  validateType({
    name: 'icon',
    value: icon,
    type: 'string',
    optional: true
  });
}

function validateWalletInterface(walletInterface) {
  validateType({
    name: 'walletInterface',
    value: walletInterface,
    type: 'object'
  });

  var name = walletInterface.name,
      connect = walletInterface.connect,
      disconnect = walletInterface.disconnect,
      address = walletInterface.address,
      network = walletInterface.network,
      balance = walletInterface.balance,
      otherParams = _objectWithoutProperties(walletInterface, ["name", "connect", "disconnect", "address", "network", "balance"]);

  invalidParams(otherParams, ['name', 'connect', 'disconnect', 'address', 'network', 'balance'], 'walletInterface');
  validateType({
    name: 'name',
    value: name,
    type: 'string'
  });
  validateType({
    name: 'connect',
    value: connect,
    type: 'function',
    optional: true
  });
  validateType({
    name: 'disconnect',
    value: disconnect,
    type: 'function',
    optional: true
  });
  validateType({
    name: 'address',
    value: address,
    type: 'object'
  });
  validateType({
    name: 'address.get',
    value: address.get,
    type: 'function',
    optional: true
  });
  validateType({
    name: 'address.onChange',
    value: address.onChange,
    type: 'function',
    optional: true
  });
  validateType({
    name: 'network',
    value: network,
    type: 'object'
  });
  validateType({
    name: 'network.get',
    value: network.get,
    type: 'function',
    optional: true
  });
  validateType({
    name: 'network.onChange',
    value: network.onChange,
    type: 'function',
    optional: true
  });
  validateType({
    name: 'balance',
    value: balance,
    type: 'object'
  });
  validateType({
    name: 'balance.get',
    value: balance.get,
    type: 'function',
    optional: true
  });
  validateType({
    name: 'balance.onChange',
    value: balance.onChange,
    type: 'function',
    optional: true
  });
}

function validateWalletInit(walletInit) {
  validateType({
    name: 'walletInit',
    value: walletInit,
    type: 'object'
  });

  var walletName = walletInit.walletName,
      apiKey = walletInit.apiKey,
      networkId = walletInit.networkId,
      infuraKey = walletInit.infuraKey,
      preferred = walletInit.preferred,
      label = walletInit.label,
      iconSrc = walletInit.iconSrc,
      svg = walletInit.svg,
      otherParams = _objectWithoutProperties(walletInit, ["walletName", "apiKey", "networkId", "infuraKey", "preferred", "label", "iconSrc", "svg"]);

  invalidParams(otherParams, ['walletName', 'apiKey', 'networkId', 'infuraKey', 'preferred', 'label', 'iconSrc', 'svg'], 'walletInitObject');
  validateType({
    name: 'walletInit.walletName',
    value: walletName,
    type: 'string'
  });
  validateType({
    name: 'walletInit.apiKey',
    value: apiKey,
    type: 'string',
    optional: true
  });
  validateType({
    name: 'walletInit.networkId',
    value: networkId,
    type: 'number',
    optional: true
  });
  validateType({
    name: 'walletInit.infuraKey',
    value: infuraKey,
    type: 'string',
    optional: true
  });
  validateType({
    name: 'walletInit.preferred',
    value: preferred,
    type: 'boolean',
    optional: true
  });
  validateType({
    name: 'walletInit.label',
    value: label,
    type: 'string',
    optional: true
  });
  validateType({
    name: 'walletInit.iconSrc',
    value: iconSrc,
    type: 'string',
    optional: true
  });
  validateType({
    name: 'walletInit.svg',
    value: svg,
    type: 'string',
    optional: true
  });
}

export { validateWalletInterface as a, validateWalletCheckModule as b, validateModal as c, isWalletCheckModule as d, validateInit as e, validateConfig as f, isWalletInit as i, validateType as v };